import { render, staticRenderFns } from "./COMatrix.vue?vue&type=template&id=9604869a&scoped=true&"
import script from "./COMatrix.vue?vue&type=script&lang=js&"
export * from "./COMatrix.vue?vue&type=script&lang=js&"
import style0 from "./COMatrix.vue?vue&type=style&index=0&id=9604869a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9604869a",
  null
  
)

export default component.exports